
































import Vue, { PropType } from 'vue';
import { OrgPeerGroup } from '@/models/orgStructure';
import * as Utils from '@/utils';

import LazyRenderingList from '@/components/LazyRenderingList.vue';
import PeerGroupCard from '@/components/PeerGroupCard.vue';
import PeerGroupListCreator from '@/components/PeerGroupListCreator.vue';
import PeerGroupSortControl from '@/components/PeerGroupSortControl.vue';

import {
  DEFAULT_PEER_GROUP_SORT,
  PeerGroupSort,
  loadPeerGroupSort,
  savePeerGroupSort
} from '@/preferences';
import { peerGroupComparator } from '@/peerGroupSort';

export default Vue.extend({
  components: {
    LazyRenderingList,
    PeerGroupCard,
    PeerGroupListCreator,
    PeerGroupSortControl
  },

  props: {
    filter: String,
    peerGroups: Array as PropType<OrgPeerGroup[]>,
    createEnabled: Boolean,
    sortEnabled: Boolean
  },

  data() {
    // Only a list that shows the control follows the saved preference; the
    // others give the viewer no way to see or change it.
    const sort = this.sortEnabled
      ? loadPeerGroupSort()
      : DEFAULT_PEER_GROUP_SORT;

    return {
      sortField: sort.field,
      sortDescending: sort.descending
    };
  },

  computed: {
    // The sort control on the left, and whatever actions the parent passes
    // on the right.
    showToolbar(): boolean {
      return this.sortEnabled || !!this.$scopedSlots.actions;
    },
    sort(): PeerGroupSort {
      return { field: this.sortField, descending: this.sortDescending };
    },
    comparator(): (a: OrgPeerGroup, b: OrgPeerGroup) => number {
      return peerGroupComparator(this.sort);
    },
    // Archived groups always follow the active ones, sorted within their block.
    sorted(): OrgPeerGroup[] {
      const active = this.peerGroups
        .filter(pg => pg.isActive)
        .sort(this.comparator);
      const archived = this.peerGroups
        .filter(pg => !pg.isActive)
        .sort(this.comparator);

      return [...active, ...archived];
    },
    filtered(): OrgPeerGroup[] {
      if (!this.filter) {
        return this.sorted;
      }

      return [
        ...Utils.findTerm(this.filter, this.sorted, pg => [
          pg.name,
          pg.section,
          pg.description
        ])
      ];
    },
    hasResults(): boolean {
      return this.filtered.length > 0;
    },
    showCreateForm(): boolean {
      return this.createEnabled && !this.hasResults && !!this.filter;
    }
  },

  methods: {
    selectSort(sort: PeerGroupSort) {
      this.sortField = sort.field;
      this.sortDescending = sort.descending;

      savePeerGroupSort(sort);
    },
    onCreate(group: { name: string; section: string; description: string }) {
      this.$emit('create-group', group);
    },

    // The create card only shows for a search with no results, so clearing
    // the search is what cancelling it means.
    clearFilter() {
      this.$emit('update-filter', '');
    }
  },

  watch: {
    filtered(current, prev) {
      if (current.length != prev.length) {
        this.$emit('filter', { count: current.length });
      }
    }
  }
});
